import { defineComponent as m, computed as f, createBlock as u, openBlock as d, resolveDynamicComponent as c, mergeProps as y, unref as i, withCtx as g, createElementBlock as v, renderSlot as s, normalizeClass as h } from "vue";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Page/page.js";
import { useOUIAProps as B } from "../../helpers/ouia.js";
import { classesFromBreakpointProps as l } from "../../breakpoints.js";
import { isDefined as w } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const C = /* @__PURE__ */ m({
  name: "PfPageSection",
  __name: "PageSection",
  props: {
    variant: { default: "default" },
    type: { default: "default" },
    filled: { type: Boolean, default: void 0 },
    widthLimited: { type: Boolean },
    maxWidth: {},
    centerAligned: { type: Boolean },
    shadowTop: { type: Boolean },
    shadowBottom: { type: Boolean },
    overflowScroll: { type: Boolean },
    component: { default: "section" },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    padding: {},
    paddingSm: {},
    paddingMd: {},
    paddingLg: {},
    paddingXl: {},
    padding2xl: {},
    sticky: {},
    stickySm: {},
    stickyMd: {},
    stickyLg: {},
    stickyXl: {},
    sticky2xl: {}
  },
  setup(n) {
    const r = {
      default: o.pageMainSection,
      subnav: o.pageMainSubnav,
      breadcrumb: o.pageMainBreadcrumb,
      tabs: o.pageMainTabs,
      wizard: o.pageMainWizard
    }, a = n, p = B({ id: a.ouiaId, safe: a.ouiaSafe }), t = f(() => a.widthLimited || w(a.maxWidth));
    return (e, k) => (d(), u(c(e.component), y(i(p), {
      class: [
        ...i(l)(e.$props, [
          "padding"
        ], i(o), { short: !0 }),
        ...i(l)(e.$props, [
          "sticky"
        ], i(o), { vertical: !0 }),
        r[e.type],
        {
          [i(o).modifiers.secondary]: e.variant === "secondary",
          [i(o).modifiers.noFill]: e.filled === !1,
          [i(o).modifiers.fill]: e.filled === !0,
          [i(o).modifiers.limitWidth]: t.value,
          [i(o).modifiers.alignCenter]: t.value && e.centerAligned && e.type !== "subnav",
          [i(o).modifiers.shadowTop]: e.shadowTop,
          [i(o).modifiers.shadowBottom]: e.shadowBottom,
          [i(o).modifiers.overflowScroll]: e.overflowScroll
        }
      ],
      style: {
        "--pf-v6-c-page--section--m-limit-width--MaxWidth": e.maxWidth
      },
      tabindex: e.overflowScroll ? 0 : void 0
    }), {
      default: g(() => [
        t.value ? (d(), v("div", {
          key: 0,
          class: h(i(o).pageMainBody)
        }, [
          s(e.$slots, "default")
        ], 2)) : s(e.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 16, ["class", "style", "tabindex"]));
  }
});
export {
  C as default
};
